export default __webpack_public_path__ + "static/media/bi_google.311a261b.svg";